import WarningIcon from "../../../../components/icons/WarningIcon";
import { validationMessages } from "../../../../constants/validation";
import { dateToyyyyMMdd } from "../../../../util/date";
import { getPatchOperations } from "../../../../util/form";
import { isValid } from "date-fns";

export const retssagsProeverFormConfig = (
  eksaminandPersonId: string,
  fmuretssagsproeveId?: string,
  numberofFailedAttempts?: number,
): FormConfig<RetssagsproeveDTO> => {
  const query = "fmuretssagsproeve";
  const queryWId = query + `/${fmuretssagsproeveId}`;
  const form: IEdit<RetssagsproeveDTO>[] = [
    {
      component: "boolean",
      id: "fiktiv",
      label: "Fiktiv?",
      initialValue: false,
      locked: !!fmuretssagsproeveId,
      isRequired: true,
      // conditionalHidden: ({ method }) => method === "patch",
    },
    {
      component: "datepicker",
      id: "proceduredato",
      label: "Proceduredato",
      initialValue: "",
      isRequired: true,
    },
    {
      component: "textarea",
      id: "tidspunkt",
      initialValue: "",
      label: "Tidspunkt",
      conditionalHidden: ({ values }) => values.fiktiv,
      isRequired: true,
    },
    {
      component: "ret",
      id: "retFirmaId",
      initialValue: "",
      label: "Ret",
      conditionalHidden: ({ values }) => values.fiktiv,
      addressSetterId: "adresse",
      isRequired: true,
    },
    {
      component: "textarea",
      id: "adresse",
      initialValue: "",
      label: "Adresse",
      conditionalHidden: ({ values }) => values.fiktiv,
      isRequired: true,
    },
    {
      component: "textinput",
      id: "retssal",
      initialValue: "",
      label: " Retssal",
      conditionalHidden: ({ values }) => values.fiktiv,
      isRequired: true,
    },
    {
      component: "textinput",
      id: "bsNummer",
      initialValue: "",
      label: "Bs-nummer",
      conditionalHidden: ({ values }) => values.fiktiv,
      isRequired: true,
    },
    {
      component: "textinput",
      id: "dommernavn",
      initialValue: "",
      label: "Dommernavn",
      conditionalHidden: ({ values }) => values.fiktiv,
      isRequired: true,
    },
    {
      component: "person",
      id: "censorPersonId",
      label: "Censor",
      placeholder: "Søg og vælg censor ...",
      erFmuretssagsproeveCensor: true,
      isRequired: false,
      conditionalHidden: ({ values }) => values.fiktiv,
    },
    {
      component: "textinput",
      id: "antalDommere",
      initialValue: "",
      label: "Antal dommere",
      conditionalHidden: ({ values }) => values.fiktiv,
      isRequired: true,
    },
    {
      component: "kode-select",
      id: "status",
      initialValue: "IkkeAfholdt",
      kodeListeType: "FmuretssagsproeveResultatKode",
      label: "Status",
      placeholder: "",
      isRequired: true,
    },
    {
      component: "textarea",
      id: "notat",
      initialValue: "",
      label: "Notat",
      placeholder: "",
      isRequired: false,
    },
  ];
  if (numberofFailedAttempts && numberofFailedAttempts > 2) {
    form.unshift({
      component: "customcomponent",
      id: "warning",
      customComponent: (
        <div className="alert alert-warning w-100 d-flex align-items-center gap-3">
          <WarningIcon />
          <div>
            <div>
              <strong>Advarsel</strong>
            </div>
            Eksaminanden har {numberofFailedAttempts} ikke-beståede
            retssagsprøver
          </div>
        </div>
      ),
    });
  }
  return {
    title: "retssagsprøve",
    get: queryWId,
    validate(values: RetssagsproeveDTO) {
      const {
        fiktiv,
        proceduredato,
        status,
        adresse,
        antalDommere,
        bsNummer,
        //censorPersonId,
        dommernavn,
        retFirmaId,
        retssal,
        tidspunkt,
      } = values;
      const errors: Partial<RetssagsproeveDTOErrors> = {};
      if (!proceduredato) errors.proceduredato = validationMessages.required;
      else if (!isValid(new Date(proceduredato))) {
        errors.proceduredato = validationMessages.invalidDate;
      }

      if (!status) errors.status = validationMessages.required;

      if (fiktiv) return errors;

      if (!tidspunkt) errors.tidspunkt = validationMessages.required;
      if (!retFirmaId) errors.retFirmaId = validationMessages.required;
      if (!adresse) errors.adresse = validationMessages.required;
      if (!retssal) errors.retssal = validationMessages.required;
      if (!bsNummer) errors.bsNummer = validationMessages.required;
      if (!dommernavn) errors.dommernavn = validationMessages.required;
      //if (!censorPersonId) errors.censorPersonId = validationMessages.required;
      if (!antalDommere) errors.antalDommere = validationMessages.required;
      else if (isNaN(antalDommere)) errors.antalDommere = "Skal være et tal";
      if (!status) errors.status = validationMessages.required;
      return errors;
    },
    form,
    post: (values) => {
      const body: RetssagsproeveDTO = {
        ...values,
        eksaminandPersonId,
        proceduredato: dateToyyyyMMdd(values.proceduredato as unknown as Date),
      };
      if (body.fiktiv) {
        delete body.tidspunkt;
        delete body.retFirmaId;
        delete body.adresse;
        delete body.retssal;
        delete body.bsNummer;
        delete body.dommernavn;
        delete body.censorPersonId;
        delete body.antalDommere;
        // delete body.notat;
      }
      const blokerHvisDumpeGraenseOverskredet =
        numberofFailedAttempts && numberofFailedAttempts > 2 ? false : true;
      return {
        query:
          query +
          "?blokerHvisDumpeGraenseOverskredet=" +
          blokerHvisDumpeGraenseOverskredet,
        body,
      };
    },
    patch(values) {
      return {
        query: queryWId,
        body: JSON.stringify(getPatchOperations(values)),
      };
    },
  };
};

type RetssagsproeveDTO = {
  fiktiv: boolean;
  status: string;
  eksaminandPersonId: string;
  censorPersonId?: string;
  proceduredato: string;
  tidspunkt?: string;
  retFirmaId?: string;
  adresse?: string;
  retssal?: string;
  bsNummer?: string;
  antalDommere?: number;
  dommernavn?: string;
  notat?: string;
};

type RetssagsproeveDTOErrors = {
  [Key in keyof RetssagsproeveDTO as Key]: string;
};
